import React from 'react';

import { CtaButton } from '@/coreComponents/buttons/CtaButton/CtaButton';

type Props = {
  text: string;
  onClick: () => void;
  loading: boolean;
  hasQuantitySelector?: boolean;
};

const AddDealToCartButton = ({ text, onClick, loading, hasQuantitySelector }: Props): JSX.Element => (
  <CtaButton
    size="large"
    labelText={text}
    clickHandler={onClick}
    fullWidth
    loading={loading}
    hasQuantitySelector={hasQuantitySelector}
  />
);

export default AddDealToCartButton;
